import { SidebarNavItem, SiteConfig } from "types";
import { env } from "@/env.mjs";
import og from "../public/_static/og.jpg";

const site_url = env.NEXT_PUBLIC_APP_URL;

export const siteConfig: SiteConfig = {
  name: "Watchero",
  description:
    "Update sites confidently. Spot visual issues at scale. Get visual differences map and exact DOM selectors of elements that changed.",
  url: site_url,
  ogImage: og.src,
  links: {
    twitter: "https://twitter.com/aguidrevitch",
    github: "https://github.com/aguidrevitch/watchero",
  },
  mailSupport: "support@watchero.io",
};

export const footerLinks: SidebarNavItem[] = [
  {
    title: "Company",
    items: [
      { title: "About", href: "#" },
      // { title: "Enterprise", href: "#" },
      { title: "Terms", href: "/terms" },
      { title: "Privacy", href: "/privacy" },
    ],
  },
  {
    title: "Product",
    items: [
      { title: "Status", href: "https://status.watchero.io/" },
      // { title: "Security", href: "#" },
      // { title: "Customization", href: "#" },
      // { title: "Customers", href: "#" },
      // { title: "Changelog", href: "#" },
    ],
  },
  {
    title: "Docs",
    items: [
      { title: "API Reference", href: "/docs" },
      // { title: "Installation", href: "#" },
      // { title: "Components", href: "#" },
      // { title: "Code Blocks", href: "#" },
    ],
  },
  {
    title: "Free Tools",
    items: [
      { title: "Screenshot Comparison", href: "/tools/screenshot-comparison" },
      { title: "Full Page Screenshot", href: "/tools/full-page-website-screenshot" },
      { title: "Open Graph Screenshot", href: "/tools/open-graph-screenshot" },
    ],
  },
];
